var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOvercast01 = function SvgOvercast01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 39.13,
    y1: 192.21,
    x2: 169.2,
    y2: 59.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -28.49,
    y1: 126.02,
    x2: 101.58,
    y2: -6.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -34.66,
    y1: 119.98,
    x2: 95.41,
    y2: -12.91,
    gradientTransform: "translate(14.16 -20.17) rotate(22.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -35.01,
    y1: 119.64,
    x2: 95.06,
    y2: -13.25,
    gradientTransform: "translate(69.16 12.12) rotate(67.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -12.18,
    y1: 141.99,
    x2: 117.89,
    y2: 9.09,
    gradientTransform: "translate(41.55 -1.88) rotate(22.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -11.33,
    y1: 142.82,
    x2: 118.74,
    y2: 9.92,
    gradientTransform: "translate(87.44 -79.85) rotate(67.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -42.69,
    y1: 112.12,
    x2: 87.38,
    y2: -20.77,
    gradientTransform: "translate(33.88 -14.04) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -29.21,
    y1: 125.32,
    x2: 100.86,
    y2: -7.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 5.08,
    y1: 158.87,
    x2: 135.15,
    y2: 25.98,
    gradientTransform: "translate(61.27 -80.16) rotate(44.99)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.2,117.29c.81-3.54,1.22-7.17,1.22-10.84,0-26.68-21.71-48.39-48.39-48.39-3,0-5.94.31-8.81.85-7.88-14.3-23.14-23.43-39.57-23.43-24.9,0-45.16,20.26-45.16,45.16,0,7.9,2.07,15.58,5.96,22.38-2.65,3.97-4.54,8.48-5.41,13.36-1.25-.14-2.51-.25-3.77-.25C14.47,116.13,0,130.6,0,148.39s14.47,32.26,32.26,32.26h22.58c0,10.67,8.68,19.35,19.36,19.35h51.61c10.67,0,19.36-8.68,19.36-19.35h22.58c17.79,0,32.26-14.47,32.26-32.26,0-14.86-10.11-27.37-23.8-31.1ZM80.65,41.94c13.52,0,26.12,7.22,33.08,18.64-13.64,4.59-24.86,15.15-30.02,28.93-4.01-1.55-8.32-2.41-12.74-2.41-9.74,0-18.63,4.03-25.1,10.52-2.57-5.26-3.94-11.04-3.94-16.97,0-21.35,17.36-38.71,38.71-38.71ZM125.81,193.55h-51.61c-7.12,0-12.9-5.79-12.9-12.9s5.79-12.9,12.9-12.9c1.23,0,2.54.23,4,.71l2.82.92,1.15-2.73c3.04-7.17,10.04-11.81,17.83-11.81s14.79,4.64,17.83,11.81l1.15,2.73,2.82-.92c1.47-.48,2.78-.71,4.01-.71,7.12,0,12.9,5.79,12.9,12.9s-5.79,12.9-12.9,12.9ZM167.74,174.19h-23.71c-2.66-7.51-9.82-12.9-18.23-12.9-1.07,0-2.16.1-3.27.32-4.52-8.12-13.09-13.22-22.53-13.22s-18.01,5.11-22.53,13.22c-1.12-.22-2.2-.32-3.27-.32-8.41,0-15.56,5.4-18.23,12.9h-23.71c-14.23,0-25.81-11.58-25.81-25.81s11.58-25.81,25.81-25.81c5.98,0,11.58,1.98,16.22,5.73l4.06-5.02c-3.04-2.46-6.51-4.31-10.2-5.53,2.31-13.78,14.41-24.22,28.63-24.22,11.06,0,21.32,6.44,26.14,16.39l5.81-2.81c-2.99-6.18-7.7-11.24-13.38-14.73,5.89-16.53,21.77-27.88,39.49-27.88,23.12,0,41.94,18.81,41.94,41.94,0,3.32-.4,6.59-1.16,9.78-.69-.04-1.37-.1-2.07-.1-17.79,0-32.26,14.47-32.26,32.26h6.45c0-14.23,11.58-25.81,25.81-25.81s25.81,11.58,25.81,25.81-11.58,25.81-25.81,25.81Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.42,
    width: 6.45,
    height: 29.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.58,
    y: 17.45,
    width: 6.45,
    height: 16.13,
    transform: "translate(-5.36 24.05) rotate(-22.49)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.28,
    y: 49.74,
    width: 6.45,
    height: 16.13,
    transform: "translate(-37.66 59.26) rotate(-67.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.44,
    y: 100.26,
    width: 16.13,
    height: 6.45,
    transform: "translate(-37.67 17.65) rotate(-22.51)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 95.42,
    y: 22.29,
    width: 16.13,
    height: 6.45,
    transform: "translate(40.3 111.35) rotate(-67.49)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.66,
    y: 19.37,
    width: 6.45,
    height: 29.03,
    transform: "translate(-14.03 33.89) rotate(-45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 77.42,
    width: 29.03,
    height: 6.45
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.89,
    y: 30.66,
    width: 29.03,
    height: 6.45,
    transform: "translate(13.35 100) rotate(-44.99)"
  })));
};
export default SvgOvercast01;